import useAxios from 'axios-hooks'
import React, { useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { toast } from 'react-toastify'

import BreadcrumbHeader from '~/components/BreadcrumbHeader'
import CustomTable from '~/components/CustomTable'
import {
  SearchParamsHandlerProvider,
  useSearchParamsHandler,
} from '~/contexts/FilterContext'
import { NumberParam, StringParam, withDefault } from 'use-query-params'
import { MODULES_DATA } from '~/constants/tutorialModules'
import { CreateLink, SubmoduleTag, TutorialTitleCell } from './styles'

const ListTutorials = () => {
  const intl = useIntl()
  const { query } = useSearchParamsHandler()

  const [{ loading, error, data }] = useAxios({
    url: '/tutorial',
    method: 'GET',
    params: {
      page: query.page,
      limit: query.limit,
      sortBy: query.sortBy,
      sort: query.sort,
    },
  })

  const BASE_COLUMNS = [
    {
      id: 'title',
      title: 'Name',
      cell: item => (
        <TutorialTitleCell href={`/tutorial/${item.id}`}>
          {item.title?.length > 45
            ? `${item.title.slice(0, 45)}...`
            : item.title}
        </TutorialTitleCell>
      ),
      sortable: true,
    },
    {
      id: 'module',
      title: 'Module',
      cell: item => (
        <div>
          <FormattedMessage id={MODULES_DATA[item.module]?.name || 'Unknown'} />
        </div>
      ),
      sortable: true,
    },
    {
      id: 'submodule',
      title: 'Submodule',
      cell: item => (
        <SubmoduleTag>
          <FormattedMessage
            id={
              MODULES_DATA[item.module]?.submodules?.[item.submodule] ||
              'Unknown'
            }
          />
        </SubmoduleTag>
      ),
      sortable: true,
    },
    {
      id: 'action',
      title: 'Action',
      centered: true,
      cell: item => (
        <div>
          <a href={`/tutorial/${item.id}/edit`}>
            <FormattedMessage id="Edit" />
          </a>
        </div>
      ),
    },
  ]

  useEffect(() => {
    if (!error) return
    toast.error(intl.formatMessage({ id: 'Failed to fetch tutorials' }))
  }, [error])

  return (
    <>
      <BreadcrumbHeader path={[{ name: 'Tutorials' }]} />
      <div style={{ marginTop: '2.25rem' }}>
        <CustomTable
          id="tutorials"
          hasPagination
          header="Tutorials"
          columns={BASE_COLUMNS}
          data={data?.tutorials}
          total={data?.total}
          loading={loading}
          paginationLeft
          menuItem={
            <CreateLink href="/tutorial/create">
              <FormattedMessage id="Add tutorial" />
            </CreateLink>
          }
        />
      </div>
    </>
  )
}

const TutorialsWrapper = () => {
  const arrayParam = withDefault(
    {
      encode: array => array,
      decode: array => array?.split(','),
    },
    []
  )
  return (
    <SearchParamsHandlerProvider
      queryParams={{
        states: withDefault(arrayParam, []),
        cities: withDefault(arrayParam, []),
        areas: withDefault(arrayParam, []),
        labels: withDefault(arrayParam, []),
        locations: withDefault(arrayParam, []),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 10),
        sort: withDefault(StringParam, ''),
        sortBy: withDefault(StringParam, ''),
        search: StringParam,
      }}
    >
      <ListTutorials />
    </SearchParamsHandlerProvider>
  )
}

export default TutorialsWrapper
